var _this = this;
import { __spreadArrays } from "tslib";
import { getWindow } from "./Dom";
/**
 * setDecelerationInterval
 * This interval will slow down with a given factor and based on baseDelay
 * Default delay calculator: (count) => baseDelay + count * baseDelay * (factor * count)
 * @param callback
 * @param baseDelay
 * @param factor    factor to slowdown with. Can also be a function
 */
export var setDecelerationInterval = function (callback, baseDelay, factor) {
    var processId;
    var count = 0;
    var getDelay = typeof factor === "function" ? factor : function (c) { return baseDelay + count * baseDelay * (factor * count); };
    var handler = function () {
        count++;
        processId = setTimeout(handler, getDelay(count));
        callback();
    };
    processId = setTimeout(handler, baseDelay);
    return function () { return clearTimeout(processId); };
};
/**
 * debounce
 * Simple lightweight debounce function
 * @credits: https://dev.to/monaye/refactor-davidwalsh-s-debounce-function-5afc
 * @param func
 * @param delay
 * @param immediate
 */
export var debounce = function (func, delay, immediate) {
    if (immediate === void 0) { immediate = false; }
    var timerId;
    var win = getWindow();
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var boundFunc = func.bind.apply(func, __spreadArrays([_this], args));
        win.clearTimeout(timerId);
        if (immediate && !timerId) {
            boundFunc();
        }
        var calleeFunc = immediate
            ? function () {
                timerId = null;
            }
            : boundFunc;
        timerId = win.setTimeout(calleeFunc, delay);
    };
};
/**
 * throttle
 * Simple lightweight throttle function
 * @credits: https://dev.to/monaye/refactor-davidwalsh-s-debounce-function-5afc
 * @param func
 * @param delay
 * @param immediate
 */
export var throttle = function (func, delay, immediate) {
    if (immediate === void 0) { immediate = false; }
    var timerId;
    var win = getWindow();
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var boundFunc = func.bind.apply(func, __spreadArrays([_this], args));
        if (timerId) {
            return;
        }
        if (immediate && !timerId) {
            boundFunc();
        }
        timerId = win.setTimeout(function () {
            if (!immediate) {
                boundFunc();
            }
            timerId = null;
        }, delay);
    };
};
/**
 * setSafeInterval
 * The problem with native interval is that it'll keep on executing
 * even though the process takes more time that the delay. This one is more
 * safe to use.
 * @note instead of a process id a function will be returned to stop the interval
 * @param cb
 * @param timeout
 */
export var setSafeInterval = function (cb, timeout) {
    var isStopped = false;
    var processId;
    var process = function () {
        if (!isStopped) {
            cb();
            processId = setTimeout(process, timeout);
        }
        else if (processId) {
            clearTimeout(processId);
        }
    };
    processId = setTimeout(process, timeout);
    return function () { return (isStopped = true); };
};
/**
 * delayPromise
 * Helper to create a Promise which will resolve after the provided amount of time
 * @param delay
 */
export var delayPromise = function (delay) { return new Promise(function (resolve) { return setTimeout(resolve, delay); }); };
//# sourceMappingURL=Timer.js.map